module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    class: {
      '-fixed-height-box': _vm.pcDisp
    },
    attrs: {
      "id": "pers-tab13",
      "name": "hres31x-tab13"
    }
  }, [_vm._l((_vm.detail.tableTalentType.rows), function(talentType, index) {
    return [_c('detail-template', {
      attrs: {
        "index": index,
        "labels": _vm.labels,
        "detail": _vm.detail,
        "pcDisp": _vm.pcDisp,
        "nowLang": _vm.nowLang,
        "mapTyptency": _vm.mapTyptency,
        "getDetailTab13Popup": _vm.getDetailTab13Popup,
        "detailTab13Popup": _vm.detailTab13Popup,
        "tab13PopupColumn": _vm.tab13PopupColumn,
        "receivedHres31xdataDetailTab13Popup": _vm.receivedHres31xdataDetailTab13Popup
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('div', [_c('div', {
              staticClass: "sub-topic-box color-skin",
              attrs: {
                "slot": "head"
              },
              on: {
                "click": function($event) {
                  _vm.toggleDisp()
                }
              },
              slot: "head"
            }, [_c('i', {
              staticClass: "fa fa-paint-brush icon-sub-topic",
              attrs: {
                "aria-hidden": "true"
              }
            }), _vm._v(" "), _c('div', {
              staticClass: "sub-topic"
            }, [_vm._v(_vm._s(talentType.typtency) + " - " + _vm._s(talentType.desc_typtency))])]), _vm._v(" "), _c('div', {
              directives: [{
                name: "show",
                rawName: "v-show",
                value: (_vm.topicDisp),
                expression: "topicDisp"
              }],
              staticClass: "data-pers-box",
              attrs: {
                "slot": "body"
              },
              slot: "body"
            }, [_c('div', {
              staticClass: "row talent-table-box"
            }, [_c('div', {
              staticClass: "col-xs-6 talent-table-heading-left bg-color-skin"
            }, [_c('div', {
              staticClass: "col-xs-12 col-sm-3 split-header"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC15']['30']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-12 col-sm-9 split-header"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC15']['40']))])]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-3 talent-table-heading-center bg-color-skin"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC15']['60']))]), _vm._v(" "), _c('div', {
              staticClass: "col-xs-3 talent-table-heading-right bg-color-skin"
            }, [_vm._v(_vm._s(_vm.labels['HRES31XC15']['50']))])]), _vm._v(" "), _vm._l((_vm.detail.tableTalentData.rows), function(talentData, TalentDataindex) {
              return [(_vm.mapTyptency(talentType.typtency, talentData.typtency)) ? [_c('div', {
                staticClass: "row talent-table-box",
                class: {
                  'highlight': !_vm.pcDisp
                }
              }, [_c('div', {
                staticClass: "col-xs-6 talent-table-body-left"
              }, [_c('div', {
                staticClass: "col-xs-12 col-sm-3 split-body cursor-pointer"
              }, [_c('a', {
                ref: "popup",
                refInFor: true,
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#tab13-popup"
                },
                on: {
                  "click": function($event) {
                    _vm.getDetailTab13Popup(talentData.codtency)
                  }
                }
              }, [_vm._v(" " + _vm._s(talentData.codtency))])]), _vm._v(" "), _c('div', {
                staticClass: "col-xs-12 col-sm-9 split-body"
              }, [_vm._v(_vm._s(talentData.desc_codtency))])]), _vm._v(" "), _c('div', {
                staticClass: "col-xs-3 talent-table-body-center"
              }, [_vm._v(_vm._s(talentData.score))]), _vm._v(" "), _c('div', {
                staticClass: "col-xs-3 talent-table-body-right"
              }, [_vm._v(_vm._s(talentData.fscore))])])] : _vm._e()]
            }), _vm._v(" "), _c('tab13-popup', {
              attrs: {
                "labels": _vm.labels,
                "nowLang": _vm.nowLang,
                "detailTab13Popup": _vm.detailTab13Popup,
                "tab13PopupColumn": _vm.tab13PopupColumn
              }
            })], 2)])
          
        },
        staticRenderFns: []
      }
    })]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-152f3323!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/tab13.vue
// module id = 3579
// module chunks = 1